import { Component, OnInit } from '@angular/core';
import { CMSService } from 'src/app/services/CMS/cms.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-site-map',
  templateUrl: './site-map.component.html',
  styleUrls: ['./site-map.component.css']
})
export class SiteMapComponent implements OnInit {
  SiteMapList:any
  Parentlist:any
  Submitted: boolean = false;

  constructor(private cmsservice: CMSService, private LookupService: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

    SiteMapModel = {
      SiteMapID: 0,
      ParentID: 0,
      SequenceNo: 0,
      Description: '',
      Title: '',
      Url: '',          
      IsActive: true

  }
  CleanSiteMap() {
    this.SiteMapModel.SiteMapID = 0;
    this.SiteMapModel.ParentID = 0;
    this.SiteMapModel.SequenceNo = 0;
    this.SiteMapModel.Description = '';
    this.SiteMapModel.Title = '';
    this.SiteMapModel.Url = '';
    this.SiteMapModel.IsActive = true;
    
  }

  EditSiteMap(item) {
    this.SiteMapModel.SiteMapID = item.SiteMapID;
    this.SiteMapModel.ParentID = item.ParentID;         
    this.SiteMapModel.Description = item.Description;
    this.SiteMapModel.Url = item.Url;
    this.SiteMapModel.Title = item.Title;
    this.SiteMapModel.SequenceNo = item.SequenceNo;
    this.SiteMapModel.IsActive = item.IsActive;
  }
  
  GetSiteMap() {
    this.cmsservice.GetSiteMap().subscribe((data: any) => {
        this.SiteMapList = data.SiteMapList;
        this.globalHelper.CheckActionStatus(data);
    });
};
SaveSiteMap(valid) { 
  this.Submitted = true;
  if (valid ) {
    this.spinnerService.show();
    this.cmsservice.SaveSiteMap(JSON.stringify(this.SiteMapModel)).subscribe((data: any) => {
      this.spinnerService.hide();
      if (data.webResponse.Status && this.SiteMapModel.SiteMapID == 0) {
        this.CleanSiteMap();
      }

      if (data.webResponse.Status) {
        this.globalHelper.CheckActionStatus(data);
        this.GetSiteMap();
      }

      this.Submitted = false;

    });
  }
};

SiteMapMarkActive(obj){
  this.CleanSiteMap();
  this.SiteMapModel.SiteMapID = obj.SiteMapID;
  this.SiteMapModel.IsActive = obj.IsActive == true ? false : true;
  obj.loading = true;
  this.cmsservice.SiteMapMarkActive(JSON.stringify(this.SiteMapModel)).subscribe((data: any) =>{
      obj.loading = false;
      this.CleanSiteMap();
      this.GetSiteMap();
      this.globalHelper.CheckActionStatus(data);
      
  });
}


  
  ngOnInit() {
    this.GetSiteMap();
    this.GetParentlist();
  }

  GetParentlist() {
    this.LookupService.GetLookupsList('SuperParentSiteMap', '').subscribe((data: any) => {
        this.Parentlist = data.LookupItems;
    });
};

}
